import { render, staticRenderFns } from "./SamplePdf.vue?vue&type=template&id=564c4d67&"
import script from "./SamplePdf.vue?vue&type=script&lang=js&"
export * from "./SamplePdf.vue?vue&type=script&lang=js&"
import style0 from "./SamplePdf.vue?vue&type=style&index=0&id=564c4d67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports